<script setup lang="ts">
import { VError } from '@/shared/ui'
</script>

<template>
    <VError />
</template>
